// Product mockup images uploaded by user.
// HOODIE = pullover (no zipper). ZIP-HOODIE = zip-up.
const HOODIE = {
  red: "https://customer-assets.emergentagent.com/job_af-toj-kiosk/artifacts/ov5nc5hn_r%C3%B8d%20hoo%20bag.jpg",
  blue: "https://customer-assets.emergentagent.com/job_af-toj-kiosk/artifacts/vnjl27u3_bl%C3%A5%20hoo%20bag.jpg",
  grey: "https://customer-assets.emergentagent.com/job_af-toj-kiosk/artifacts/8r5o1lw9_gr%C3%A5%20hoo%20bag.jpg",
  black: "https://customer-assets.emergentagent.com/job_af-toj-kiosk/artifacts/ezdetlie_sort%20hoo%20bag.jpg",
  group: "https://customer-assets.emergentagent.com/job_af-toj-kiosk/artifacts/o57nbb6x_alle%20hoo.jpg",
};

const ZIP = {
  red: HOODIE.red,
  blue: HOODIE.blue,
  grey: HOODIE.grey,
  black: HOODIE.black,
  group: "https://customer-assets.emergentagent.com/job_af-toj-kiosk/artifacts/4f08xd8g_alle%20hood.jpg",
};

// T-shirt mockup images
const TSHIRT = {
  red: "https://customer-assets.emergentagent.com/job_af-toj-kiosk/artifacts/rxao3pjh_r%C3%B8d%20t%20bag.jpg",
  blue: "https://customer-assets.emergentagent.com/job_af-toj-kiosk/artifacts/sdrmom53_bl%C3%A5%20t%20bag.jpg",
  grey: "https://customer-assets.emergentagent.com/job_af-toj-kiosk/artifacts/93bcle76_gr%C3%A5%20t%20bag.jpg",
  white: "https://customer-assets.emergentagent.com/job_af-toj-kiosk/artifacts/4n9xrg6g_hvid%20t%20bag.jpg",
  group: "https://customer-assets.emergentagent.com/job_af-toj-kiosk/artifacts/afdyquwo_alle%20t.jpg",
};

export const PRODUCTS = [
  {
    id: "tshirt",
    name: "T-shirt",
    price: 150,
    group_image: TSHIRT.group,
    colors: [
      { value: "red", label: "Rød", hex: "#DC2626", image_url: TSHIRT.red },
      { value: "blue", label: "Blå", hex: "#1E3A8A", image_url: TSHIRT.blue },
      { value: "grey", label: "Grå", hex: "#9CA3AF", image_url: TSHIRT.grey },
      { value: "white", label: "Hvid", hex: "#FFFFFF", image_url: TSHIRT.white },
    ],
  },
  {
    id: "hoodie",
    name: "Hoodie",
    price: 250,
    group_image: HOODIE.group,
    colors: [
      { value: "red", label: "Rød", hex: "#DC2626", image_url: HOODIE.red },
      { value: "blue", label: "Blå", hex: "#1E3A8A", image_url: HOODIE.blue },
      { value: "grey", label: "Grå", hex: "#9CA3AF", image_url: HOODIE.grey },
      { value: "black", label: "Sort", hex: "#0F172A", image_url: HOODIE.black },
    ],
  },
  {
    id: "zip_hoodie",
    name: "Zip-Hoodie",
    price: 275,
    group_image: ZIP.group,
    colors: [
      { value: "red", label: "Rød", hex: "#DC2626", image_url: ZIP.red },
      { value: "blue", label: "Blå", hex: "#1E3A8A", image_url: ZIP.blue },
      { value: "grey", label: "Grå", hex: "#9CA3AF", image_url: ZIP.grey },
      { value: "black", label: "Sort", hex: "#0F172A", image_url: ZIP.black },
    ],
  },
];

export const SIZES = ["4-6", "8-10", "12-14", "XS", "S", "M", "L", "XL", "XXL", "XXXL"];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_9ef4393f-a7a9-47e2-a010-1a64b31fec7f/artifacts/3zllcag0_%C3%85F%20logo.jpg";
